<template>

<div style="width:100%;">

    <div class="py-3" style="border: 1px solid black">
        <div class="tabs is-centered is-boxed is-boxed">
            <ul>
                <li :class=" {'is-active': activeMenuTab === 'logic'} ">
                    <a @click=" activeMenuTab = 'logic' ">
                        <span class="icon is-small"><i class="fa-solid fa-code-branch" aria-hidden="true"></i></span>
                        <span>Logic</span>
                    </a>
                </li>
                <li :class=" {'is-active': activeMenuTab === 'actions'} ">
                    <a @click=" activeMenuTab = 'actions' ">
                        <span class="icon is-small"><i class="fa-solid fa-person-running" aria-hidden="true"></i></span>
                        <span>Actions</span>
                    </a>
                </li>
                <li :class=" {'is-active': activeMenuTab === 'variables'} ">
                    <a @click=" activeMenuTab = 'variables' ">
                        <span class="icon is-small"><i class="fa-solid fa-database" aria-hidden="true"></i></span>
                        <span>Variables</span>
                    </a>
                </li>
                <li :class=" {'is-active': activeMenuTab === 'values'} ">
                    <a @click=" activeMenuTab = 'values' ">
                        <span class="icon is-small"><i class="fa-solid fa-ruler" aria-hidden="true"></i></span>
                        <span>Values</span>
                    </a>
                </li>
                <li :class=" {'is-active': activeMenuTab === 'modifiers'} ">
                    <a @click=" activeMenuTab = 'modifiers' ">
                        <span class="icon is-small"><i class="fa-solid fa-plus-minus" aria-hidden="true"></i></span>
                        <span>Modifiers</span>
                    </a>
                </li>
            </ul>
        </div>
        <div>
            <MenuTabLogic @selected="addNode" v-if="activeMenuTab === 'logic'" :trigger-type=" triggerType " ref="MenuTabLogic" />
            <MenuTabActions @selected="addNode" v-if="activeMenuTab === 'actions'" :trigger-type=" triggerType " ref="MenuTabActions" />
            <MenuTabVariables @selected="addNode" v-if="activeMenuTab === 'variables'" :trigger-type=" triggerType " ref="MenuTabVariables" />
            <MenuTabValues @selected="addNode" v-if="activeMenuTab === 'values'" :trigger-type=" triggerType " ref="MenuTabValues" />
            <MenuTabModifiers @selected="addNode" v-if="activeMenuTab === 'modifiers'" :trigger-type=" triggerType " ref="MenuTabModifiers" />
        </div>
    </div>
    <div ref="triggerwrapper" class="has-text-centered is-relative litegraph" style="width:100%;border:1px solid black;">
        <span class="is-absolute is-top-right mt-1 mr-1 has-text-white is-italic is-size-7 cursor-pointer is-underlined-on-hover"
              @click=" $modal.show('view-database-structure-modal') ">View Data Structure</span>
        <div>
            <canvas ref="triggercanvas" id="trigger-canvas"></canvas>
        </div>
        <div v-if=" !trigger ">
            <div class="xerocraft-loading">
                <div>
                    <p>
                        <img :src=" $store.state.assetRoute + '/images/loading.gif' " alt="Loading Icon">
                    </p>
                </div>
            </div>
        </div>
    </div>
    <div class="buttons is-centered mt-4">
        <div class="button is-primary is-large" @click="exportGraph">SAVE</div>
    </div>





    <modal
        name="send-email-action"
        :adaptive="true"
        :scrollable="true"
        :width="1000"
        :height="'auto'">
        <div class="is-padded">
            <button type="button" class="delete is-top-right has-margins-05" aria-label="close prepare email window" @click=" $modal.hide('send-email-action') "></button>
            <h4 class="title is-4">Compose your email.</h4>

            <div class="field">
                <label for="mvsubject" class="label required">Subject</label>
                <div class="control">
                    <input type="text" id="mvsubject" class="input" name="subject" v-model="nodeData.bucket1" />
                </div>
            </div>

            <div class="field">
                <label for="mvbody" class="label required">Body</label>
                <div class="control">
                    <xero-textarea id="mvbody" name="body" :value="nodeData.bucket2" class="textarea" @input="(e) => {nodeData.bucket2=e;}"></xero-textarea>
                </div>
            </div>

            <div class="field content">
                <p>Your email can be personalized with the information contained within the input fields!</p>
                <ul>
                    <li><span v-pre>To include any of the variables from the user/email input, type the following: {{ $d['VARIABLE_NAME'] }}</span></li>
                    <li><span v-pre>To include any of the variables from the extra data input, type the following: {{ $e['VARIABLE_NAME'] }}</span></li>
                </ul>
                <details>
                    <summary>Content options</summary>
                    <ul>
                        <li>To make a header, put a "# " in front of the text <u>on it\'s own line.</u> (don\'t forget the extra space after the "#")</li>
                        <li>To make a subheader, put a "## " in front of the text <u>on it\'s own line.</u> (don\'t forget the extra space after the "##"). You can make sub-sub headers too.</li>
                        <li>To make a list, put a "* " in front of the text <u>on it\'s own line.</u> (don\'t forget the extra space after the "*")</li>
                        <li>To make a panel, put the following: <br>@component('mail::panel') PANEL CONTENT @endcomponent</li>
                        <li>To make a style button, put the following: <br>@component('mail::button', ['url' => 'https://xerocraft.org/example-url']) BUTTON TEXT @endcomponent</li>
                        <li>To make a plain link, it is recommended you use the following: <br>@component('mail::plain-link', ['url' => 'https://xerocraft.org/example-url']) LINK TEXT @endcomponent</li>
                    </ul>
                </details>
                <details>
                    <summary>Advanced Tricks</summary>
                    <ul>
                        <li v-pre>You can put conditional text in your emails depending on variables. For example, if you want to say something different to an administrator, you can put: <br>{{ $admin === 1 ? "TEXT TO ADMIN HERE" : "TEXT TO NON-ADMIN HERE" }} (Note the "?", and the ":". This is called a "Shorthand If / Else Statement in PHP" if you would like to google more information about these.</li>
                        <li>You can use If-Else-Statements, and other types of statements with "@" symbols. For example: @if($admin === 1) Hello Administrator! @else Hello Member! @endif</li>
                        <li>To learn more about If-Else-Statement usage in this way, google "Laravel Blade Templates"</li>
                    </ul>
                </details>

            </div>

            <div class="buttons is-centered">
                <button @click=" runNodeMethod('saveEmailCompose', {subject: nodeData.bucket1, body: nodeData.bucket2, sendEmail: nodeData.node}) " class="button is-primary">
                    Save
                </button>
                <button @click=" $modal.hide('send-email-action') " class="button" type="button">Close</button>
            </div>

        </div>
    </modal>



    <modal
        name="litegraph-date-picker"
        :adaptive="true"
        :scrollable="true"
        :width="300"
        styles="overflow:visible;"
        :height="'auto'">
        <div class="is-padded">
            <button type="button" class="delete is-top-right has-margins-05" aria-label="close prepare email window" @click=" $modal.hide('litegraph-date-picker') "></button>
            <h4 class="title is-4">Date Picker</h4>



            <div class="field">

                <div class="control">
                    <VueCtkDateTimePicker
                        v-model="nodeData.bucket1"
                        format="YYYY-MM-DD HH:mm:ss" />
                </div>
            </div>

            <div class="buttons is-centered">
                <button @click=" runNodeMethod('saveDatePicker', {date: nodeData.bucket1, node: nodeData.node}) " class="button is-primary">
                    Save
                </button>
                <button @click=" $modal.hide('litegraph-date-picker') " class="button" type="button">Close</button>
            </div>

        </div>
    </modal>



    <modal
        name="litegraph-item-picker"
        :adaptive="true"
        :scrollable="true"
        :width="500"
        styles="overflow:visible;"
        :height="'auto'">
        <div class="is-padded">
            <button type="button" class="delete is-top-right has-margins-05" aria-label="close selection window" @click=" $modal.hide('litegraph-item-picker') "></button>
            <h4 class="title is-4">{{ itemPickerType || '' }} Picker</h4>

            <div class="field">
                <div class="control">
                    <input type="text"
                           name="Filter-Items"
                           placeholder="Search"
                           class="input"
                           v-model="itemSearching"
                           @keyup=" searchItems "
                    >
                </div>
            </div>

            <div class="box filterOutput has-floating-children" v-show=" filteredItemResults.length > 0 ">
                <div v-for=" filtered in filteredItemResults ">
                    <div class="card cursor-pointer p-3 m-3 is-primary-on-hover"
                         @click=" ()=>{nodeData.bucket1 = filtered;runNodeMethod('save'+(itemPickerType || '')+'Picker', {item: nodeData.bucket1, node: nodeData.node}) }"
                    >{{ filtered }}</div>
                </div>
            </div>

            <div class="buttons is-centered">
                <button @click=" $modal.hide('litegraph-item-picker') " class="button" type="button">Close</button>
            </div>

        </div>
    </modal>



    <modal
        name="view-database-structure-modal"
        :adaptive="true"
        :scrollable="true"
        :width="500"
        styles="overflow:visible;"
        :height="'auto'">
        <div class="is-padded">
            <button type="button" class="delete is-top-right has-margins-05" aria-label="close database viewer window" @click=" $modal.hide('view-database-structure-modal') "></button>
            <h4 class="title is-4">Data Viewer</h4>

            <details class="message" v-for=" model in sortedModels ">
                <summary class="message-header"><i :class="model.icon"></i>{{ model.name }}</summary>
                <div>
                    <details class="card" v-if=" model.relations && !$isEmptyObject(model.relations) ">
                        <summary class="card-header"><span class="card-header-title">Relationships</span></summary>
                        <div class="card-content content">
                            <ul class="mt-0">
                                <li v-for=" r in Object.keys(model.relations) ">
                                    <span class="is-size-6 has-text-weight-bold">{{ model.relations[r].title }}</span>
                                    <ul class="mt-0">
                                        <li>Type: <i>{{ model.relations[r].model }}</i></li>
                                        <li>Quantity: <i>{{ model.relations[r].quantity }}</i></li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                    </details>
                    <details class="card" v-if=" model.properties && !$isEmptyObject(model.properties) ">
                        <summary class="card-header"><span class="card-header-title">Variables</span></summary>
                        <div class="card-content content">
                            <ul class="mt-0">
                                <li v-for=" p in Object.keys(model.properties) ">
                                    <span><b>{{ p }}</b> <i class="is-size-7">[{{ model.properties[p].type }}]</i></span>
                                </li>
                            </ul>
                        </div>
                    </details>
                </div>
            </details>

        </div>
    </modal>


    <div class="xerocraft-loading" v-if=" loading ">
        <div>
            <p>
                <img :src=" $store.state.assetRoute + '/images/loading.gif' " alt="Loading Icon">
            </p>
        </div>
    </div>
</div>

</template>
<script>
import {LGraph, LGraphCanvas, LGraphNode, LiteGraph} from 'litegraph.js';
import 'litegraph.js/css/litegraph.css';
import MenuTabLogic from "../Child-Assets/MenuTabLogic";
import MenuTabActions from "../Child-Assets/MenuTabActions";
import MenuTabVariables from "../Child-Assets/MenuTabVariables";
import MenuTabValues from "../Child-Assets/MenuTabValues";
import MenuTabModifiers from "../Child-Assets/MenuTabModifiers";
import NodeTypes from '../Child-Assets/Node-Types';

export default {
    name: 'Trigger-Builder',
    props: {
        routeSave: {
            type: String,
            required: true
        },
        routeDashboard: {
            type: String,
            required: true
        },
        routeLoadTrigger: {
            type: String,
            required: true
        },
        routeNodeSearching: {
            type: String,
            required: true
        },
        triggerType: {
            type: String,
            required: true
        },
        triggerInfo: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            trigger: null,
            graph: null,
            canvas: null,
            bounding: null,
            liteGraph: LiteGraph,
            loading: false,

            activeMenuTab: 'logic',
            nodes: [],
            nodeMethods: {},
            nodeData: {
                bucket1: null,
                bucket2: null,
                bucket3: null,
                node: {}
            },

            itemSearching: '',
            itemPickerType: '',
            filteredItemResults: [],
        };
    },
    computed: {
        sortedModels() {
            let models = Object.keys(this.triggerInfo.models);
            models = models.sort();
            // return models;
            models.forEach((m, i) => {
                models[i] = this.triggerInfo.models[m];
            });

            return models;
        }
    },
    methods: {
        center(offsetX = 0, offsetY = 0) {
            let rect = this.canvas.ds.element.getBoundingClientRect();
            return this.canvas.convertCanvasToOffset([
                (rect.width * 0.5) + offsetX,
                (rect.height * 0.5) + offsetY
            ]);
        },
        runNodeMethod(method, allArguments, buildArgs = false) {
            if(this.nodeMethods[method]) {
                if(buildArgs && allArguments && Object.keys(allArguments).length > 0) {
                    Object.keys(allArguments).forEach((a) => {
                        this.nodeData[a] = allArguments[a];
                    });
                }
                this.nodeMethods[method](allArguments);
            }
        },
        resize() {
            const { triggercanvas, triggerwrapper } = this.$refs;
            triggercanvas.width = triggerwrapper.clientWidth;
            triggercanvas.style.width = `${triggerwrapper.clientWidth}px`;
            triggercanvas.height = triggerwrapper.clientWidth * 0.65;
            triggercanvas.style.height = `${(triggerwrapper.clientWidth * 0.65)}px`;
        },
        addNode(type) {
            let node = this.liteGraph.createNode(type);
            node.pos = this.center(-100,-100);
            this.graph.add(node);
        },
        loadTrigger() {
            this.loading = true;
            this.$http.post(this.routeLoadTrigger)
                .then(response => {
                    this.$d('response');
                    this.$d(response);
                    if (response.data.hasErrors) {
                        this.$store.commit('errors', response.data.errors);
                    } else if (response.data.success === true && response.data.trigger) {
                        this.trigger = response.data.trigger;
                        this.initiate();
                    } else if (response.data.errors) {
                        this.$store.commit('errors', response.data.errors);
                    } else {
                        this.$store.commit('error', response.data.message);
                    }
                    this.loading = false;
                })
                .catch(error => {
                    this.$displayError(error);
                    this.loading = false;
                });
        },
        initiate() {
            this.resize();
            window.addEventListener("resize", this.resize);
            let self = this;
            window.settingUpGraph = true;

            this.liteGraph.NODE_TEXT_COLOR = '#4a4a4a';

            class CustomLGraph extends LGraph {
                remove(node) {
                    if(node.constructor.name !== 'PinnedNode') super.remove(node);
                    else self.$store.commit('error', 'You cannot delete the main trigger action.');
                }
            }
            class PinnedNode {
                constructor(mutator){
                    this.title = self.triggerInfo.models[self.trigger.model].name;
                    this.addOutput(self.trigger.type, 'model,pinned,'+self.trigger.model);
                    this.shape = LiteGraph.CARD_SHAPE;
                    this.boxcolor = '#f38135';
                    this.bgcolor = '#f38135';
                    this.size = [200,50];
                    this.properties = {modelProperties: self.triggerInfo.models[self.trigger.model]}
                }
            }

            this.graph = new CustomLGraph();
            this.canvas = new LGraphCanvas("#trigger-canvas", this.graph);

            this.liteGraph.clearRegisteredTypes();

            this.liteGraph.registerNodeType("pinned/trigger",PinnedNode);
            if(!this.trigger.graph) {
                let node_const = this.liteGraph.createNode("pinned/trigger");
                let rect = this.canvas.ds.element.getBoundingClientRect();
                node_const.pos = this.center((-1 * (rect.width / 2)) + 50, -50);
                this.graph.add(node_const);
            }

            LGraphNode.prototype.getParentNode = function(slot = 0)  {
                if (!this.inputs) {
                    return null;
                } //undefined;

                if (slot >= this.inputs.length || this.inputs[slot].link == null) {
                    return null;
                }
                var link_id = this.inputs[slot].link;
                var link = this.graph.links[link_id];
                if (!link) {
                    //bug: weird case but it happens sometimes
                    return null;
                }
                var node = this.graph.getNodeById(link.origin_id);
                if (!node) {
                    return null;
                }
                return node;
            }

            for(const i in NodeTypes) {
                if(NodeTypes[i].path) this.liteGraph.registerNodeType(NodeTypes[i].path,NodeTypes[i]);
                if(NodeTypes[i].vueMethods && !this.$isEmptyObject(NodeTypes[i].vueMethods)) {
                    Object.keys(NodeTypes[i].vueMethods).forEach((m) => {
                        this.nodeMethods[m] = function(...args) {
                            NodeTypes[i].vueMethods[m](...args);
                        }
                    });
                }
            }

            if(this.trigger.graph) {
                this.graph.configure(this.trigger.graph, false);
            }

            this.graph.start()

            window.settingUpGraph = false;

        },
        exportGraph() {
            this.loading = true;
            this.$d('GRAPH', this.graph);
            let graph = this.graph.serialize();
            this.$d('GRAPH serialized', graph, true);

            this.$http.post(this.routeSave, {
                trigger: this.trigger.id,
                graph: graph
            })
                .then(response => {
                    this.loading = false;
                    this.$d('response');
                    this.$d(response);
                    if (response.data.hasErrors) {
                        this.$store.commit('errors', response.data.errors);
                    } else if (response.data.error) {
                        this.$store.commit('error', response.data.error);
                    } else if (response.data.success === true) {
                        this.$goTo(this.routeDashboard);
                    } else {
                        this.$store.commit('error', response.data.message);
                    }
                })
                .catch(error => {
                    this.loading = false;
                    this.$displayError(error);
                });
        },



        searchItems: function() {
            if (!this.itemSearching || !this.itemSearching.length) {
                this.filteredItemResults = [];
                return;
            }

            this.$http.post(this.routeNodeSearching, {
                type: this.itemPickerType || '',
                criteria: this.itemSearching
            })
                .then((response) => {
                    this.$d(response);
                    this.filteredItemResults = response.data.results;
                })
                .catch((error) => {
                    this.$d(error);
                    this.$d(error.response);
                });
        }
    },
    mounted() {
        window.triggerInfo = this.triggerInfo;
        window.VueApp.container.graphStatus =  'build';
        this.loadTrigger();
    },
    components: {
        MenuTabLogic,
        MenuTabActions,
        MenuTabVariables,
        MenuTabValues,
        MenuTabModifiers,
    }
}
</script>
